import React from 'react';
import PropTypes from 'prop-types';
import ReactCountryFlag from 'react-country-flag';
import isEmpty from 'lodash/isEmpty';
import { optimiseImage } from 'src/common/utils/prismic-image';

const CountryFlag = (props) => {
  if (!props.selectedCountry) {
    return null;
  } else if (!isEmpty(props.flagCountry)) {
    return (
      <img
        src={optimiseImage(props.flagCountry.flag.url, {
          auto: 'format,compress'
        })
        }
        alt={props.flagCountry.code}
        width="30"
        className="country-toggle-image"
      />
    );
  }
  return <ReactCountryFlag code={props.selectedCountry} />;
};

CountryFlag.propTypes = {
  selectedCountry: PropTypes.string,
  flagCountry: PropTypes.shape({
    flag: PropTypes.shape({
      url: PropTypes.string
    }),
    code: PropTypes.string,
  }),
};

export default CountryFlag;



// WEBPACK FOOTER //
// ./src/client/js/view/components/UserForm/CountryFlag/CountryFlag.js